import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'stageFormat',
})
export class StageFormatPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        return (
            this.formatFirstValue(value) +
            this.formatSecondValue(
                this.formatNumberAndStringNd(value.phase),
                this.isNullOrEmpty(value.title),
            )
        )
    }

    formatSecondValue(phaseFormat, titleFormat) {
        let strRes = '('
        if (phaseFormat.length > 0) {
            strRes += phaseFormat
        }
        if (titleFormat.length > 0) {
            strRes += strRes.length === 1 ? titleFormat : ' ' + titleFormat
        }
        strRes += ')'
        return strRes.length === 2 ? '' : ' ' + strRes
    }

    formatFirstValue(object) {
        if (object.all === 0) {
            return 'Planing'
        }
        return (object.count ? object.count : '-') + ' / ' + object.all
    }

    formatNumberAndStringNd(value) {
        if (Number.isInteger(Number(value))) {
            switch (Number(value)) {
                case 1:
                    return value + 'st'
                case 2:
                    return value + 'nd'
                case 3:
                    return value + 'rd'
                case 4:
                case 5:
                case 6:
                    return value + 'th'
            }
        }
        return this.capitalizeFirstLetter(this.isNullOrEmpty(value))
    }

    isNullOrEmpty(value) {
        return value ? value : ''
    }

    capitalizeFirstLetter(string) {
        return string.length > 0 ? string.charAt(0).toUpperCase() + string.slice(1) : ''
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/stage-format.pipe.ts